import axios from 'axios';

import getAuthSession from './auth';

export interface WebSocketTicket {
  token: string;
  expiresAt: string;
}

// Mint a short-lived, single-use ticket for opening a WebSocket connection. Uses the ID
// token, matching every other authed call in the app.
export async function fetchTicket(): Promise<WebSocketTicket> {
  const authSession = await getAuthSession();
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_API}/auth/websocket-ticket/`,
    {},
    {
      headers: { Authorization: `Bearer ${authSession.getIdToken().getJwtToken()}` },
    },
  );
  return response.data as WebSocketTicket;
}

// Build the wss URL. Only the short-lived ticket travels in the query string.
export function buildSocketUrl(ticket: string): string {
  return `${process.env.REACT_APP_WS_BASE}?ticket=${encodeURIComponent(ticket)}`;
}
